import {useLayoutEffect, useState} from 'react';

type MediaQueryType = Array<string>;
type MatchedMediaType = Array<boolean>;

const useMediaQuery = (queries: MediaQueryType, defaultValues: MatchedMediaType = []) => {
    const mediaQueryLists = queries.map((query: string) => window.matchMedia(query));
    const initialValues = defaultValues.length ? defaultValues : Array(queries.length).fill(false);

    const getValue = (): MatchedMediaType => {
        return mediaQueryLists.map((mediaQuery: any) => mediaQuery.matches)
    }

    const [value, setValue] = useState(getValue)

    useLayoutEffect(() => {
        const handler = (): void => setValue(getValue);

        mediaQueryLists.forEach((mediaQuery: any) => mediaQuery.addListener(handler));

        return (): void => mediaQueryLists.forEach((mediaQuery: any) => mediaQuery.removeListener(handler));
    }, [])

    return typeof window === 'undefined' ? initialValues : value;
}

export default useMediaQuery